import type { MinMax } from '../../../../../charts/core/types/min-max.js';
import { useDataTableV2 } from '../../../contexts/DataTableV2Context.js';

export const useMinMaxFromConfig = (id: string = ''): MinMax => {
  const table = useDataTableV2();
  return (
    table.getState().ganttMinMaxValues?.[id] ?? {
      min: 0,
      max: 0,
    }
  );
};
